import { render, staticRenderFns } from "./cariaracomp.vue?vue&type=template&id=b07ed6da&scoped=true&"
import script from "./cariaracomp.vue?vue&type=script&lang=js&"
export * from "./cariaracomp.vue?vue&type=script&lang=js&"
import style0 from "./cariaracomp.vue?vue&type=style&index=0&id=b07ed6da&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b07ed6da",
  null
  
)

export default component.exports